import router from '@/router'

export default {
  strict: true,
  state: {
    userdata: {
      userid: null,
      accesstoken: null,
      fname: null,
      lname: null,
      usertype: null,
      countryid: null
    },
    configheader: {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': null
      }
    }
  },
  actions: {
    login ({commit, dispatch}, userData) {
      commit('setAuthUser', userData)
      localStorage.setItem('userid', JSON.stringify(userData.userid))
      localStorage.setItem('accesstoken', userData.accesstoken)
      localStorage.setItem('fname', userData.fname)
      localStorage.setItem('lname', userData.lname)
      localStorage.setItem('usertype', userData.usertype)
      localStorage.setItem('countryid', JSON.stringify(userData.countryid))
    },
    tryAutoLogin ({commit, dispatch}) {
      const accesstoken = localStorage.getItem('accesstoken')
      if (!accesstoken) {
        return
      }
      const userid = JSON.parse(localStorage.getItem('userid'))
      const fname = localStorage.getItem('fname')
      const lname = localStorage.getItem('lname')
      const usertype = localStorage.getItem('usertype')
      const countryid = JSON.parse(localStorage.getItem('countryid'))
      commit('setAuthUser', {
        userid: userid,
        accesstoken: accesstoken,
        fname: fname,
        lname: lname,
        usertype: usertype,
        countryid: countryid
      })
      dispatch('innitialiseData')
    },
    logout ({commit}) {
      commit('clearAuthUser')
      localStorage.removeItem('userid')
      localStorage.removeItem('accesstoken')
      localStorage.removeItem('fname')
      localStorage.removeItem('lname')
      localStorage.removeItem('usertype')
      localStorage.removeItem('countryid')
      router.push({
        name: 'login'
      })
    }
  },
  mutations: {
    clearAuthUser (state) {
      state.userdata.userid = null
      state.userdata.accesstoken = null
      state.userdata.fname = null
      state.userdata.lname = null
      state.userdata.usertype = null
      state.userdata.countryid = null
      state.configheader.headers.Authorization = null
      localStorage.removeItem('userid')
      localStorage.removeItem('accesstoken')
      localStorage.removeItem('fname')
      localStorage.removeItem('lname')
      localStorage.removeItem('usertype')
      localStorage.removeItem('countryid')
    },
    setAuthUser (state, userData) {
      state.userdata.userid = userData.userid
      state.userdata.accesstoken = userData.accesstoken
      state.userdata.fname = userData.fname
      state.userdata.lname = userData.lname
      state.userdata.usertype = userData.usertype
      state.userdata.countryid = userData.countryid
      state.configheader.headers.Authorization = 'Bearer ' + state.userdata.accesstoken
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.userdata.accesstoken !== null
    },
    getheader (state) {
      return state.configheader
    },
    gettoken (state) {
      return state.userdata.accesstoken
    },
    getFullname (state) {
      return state.userdata.fname + ' ' + state.userdata.lname
    },
    getUsertype (state) {
      return state.userdata.usertype
    },
    getUserid (state) {
      return state.userdata.userid
    },
    getUsercountryid (state) {
      return state.userdata.countryid
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js